module.exports = __webpack_public_path__ + "static/media/icon-clear.d529de5c.svg";